// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"126ae86d","455":"7f41b833","977":"b7416bec"}[chunkId] + ".chunk.js";
};